import { ResidentRegistrationForm } from "@project/admin/components/resident-registration-form";

export default function ResidentRegistrationPage() {
  return <ResidentRegistrationForm />;
}
